import { API_STATUS } from 'core-lib/constants/network';
import dynamic from 'next/dynamic';
import { useEffect } from 'react';
import useCart from '../../hooks/useCart';
import useParkplusStoreV2 from '../../hooks/useParkplusStoreV2';
import useStoreHome from '../../hooks/useStoreHome';
import Layout, { LayoutType } from '../../types/layout';

import AnimatedImage from 'core-lib/components/AnimatedImage';
import Searchbar from '../../uiComponents/Searchbar';
import StoreAppBar from '../../uiComponents/StoreAppBar';
import { trackPageLoadStoreV2 } from '../../utils/events';
import HomePageShimmer from '../HomePageShimmer';
import s from './Home.module.scss';
import PaginateLayouts from './PaginateLayouts';
const CartCta = dynamic(() => import('../../uiComponents/CartCta'), {
  ssr: false,
});
const FreeMlWidget = dynamic(() => import('../../uiComponents/FreeMlWidget'), {
  ssr: false,
});

export const Home = ({ data }) => {
  const festiveTheme = data?.STORE_HOMEPAGE;
  const searchSuggestions = data?.STORE_HOMEPAGE?.search_suggestions;

  useCart(true);
  const { fetchHomePage } = useStoreHome();
  const { storeHomepageData, storeHomepageApiStatus, mlExclusivepageApiStatus } =
    useParkplusStoreV2();

  useEffect(() => {
    trackPageLoadStoreV2();
  }, []);

  useEffect(() => {
    if (storeHomepageApiStatus === API_STATUS.default) {
      fetchHomePage('STORE_HOMEPAGE');
    }
  }, [storeHomepageApiStatus, mlExclusivepageApiStatus, fetchHomePage]);

  const freeMlWidget =
    storeHomepageData.find((item: Layout) => item.layoutType === LayoutType.FreeMlListing) || -1;

  return (
    <div className={s.root}>
      <StoreAppBar
        title="Store"
        showCart
        showBackGroundColor={false}
        showAddressBar
        renderAppBarOnly
        isSticky
        themeColor={festiveTheme?.theme}
        statusBarColor={festiveTheme?.status_color}
      />
      {festiveTheme?.header_image && (
        <div className={s.headerImage}>
          <AnimatedImage src={festiveTheme?.header_image} />
        </div>
      )}
      <div className={s.container}>
        <Searchbar searchSuggestions={searchSuggestions} />

        {/* {freeMlWidget !== -1 && <FreeMlWidget data={freeMlWidget} />} */}
      </div>

      {API_STATUS.success === storeHomepageApiStatus || storeHomepageData.length > 0 ? (
        <PaginateLayouts />
      ) : (
        <HomePageShimmer
          showHalf
          backgroundData={festiveTheme}
          searchSuggestions={searchSuggestions}
        />
      )}
      <CartCta />
    </div>
  );
};
